interface StampDayProps {
  day?: keyof typeof dayTitle;
  status?: 'normal' | 'fail' | 'success';
  isToday?: boolean;
  className?: string;
}

export const StampDay = ({ day = 4, status = 'normal', isToday = false, className }: StampDayProps) => (
  <div className={`w-full h-full ${className}`}>
    <svg width="100%" height="100%" viewBox="0 0 274 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.5" y="28.5" width="262" height="190" fill="white" stroke="black" strokeWidth="3" />
      {/* content items */}
      {status === 'normal' ? dayFillItems[day] : fillItems[status]}
      <rect x="1.5" y="24.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="262.5" y="24.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="1.5" y="212.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="262.5" y="212.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      {/* title color */}
      <rect x="30.5" y="1.5" width="212" height="54" fill={isToday ? fillTitleColor.today : fillTitleColor.normal} />
      {/* title border */}
      <rect x="30.5" y="1.5" width="212" height="54" stroke="black" strokeWidth="3" />
      {/* title text */}
      {dayTitle[day] ?? dayTitle[1]}
    </svg>
  </div>
);

export const StampToday = ({
  day = 1,
  voteCount = 3,
  status,
  className,
}: StampDayProps & { voteCount?: keyof typeof voteStamp; className?: string }) => (
  <div className={`w-full h-full ${className}`}>
    <svg width="100%" height="100%" viewBox="0 0 274 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.5" y="28.5" width="262" height="190" fill="white" stroke="black" strokeWidth="3" />
      {/* content items */}
      {status === 'success' ? fillItems.success : voteStamp[voteCount]}
      <rect x="1.5" y="24.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="262.5" y="24.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="1.5" y="212.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      <rect x="262.5" y="212.5" width="10" height="10" fill="black" stroke="black" strokeWidth="3" />
      {/* title color */}
      <rect x="30.5" y="1.5" width="212" height="54" fill={fillTitleColor.today} />
      {/* title border */}
      <rect x="30.5" y="1.5" width="212" height="54" stroke="black" strokeWidth="3" />
      {/* title text */}
      {dayTitle[day] ?? dayTitle[1]}
    </svg>
  </div>
);

const dayFillItems = {
  1: (
    <path
      d="M110.022 134.85V140.25C110.022 145.85 106.272 149.1 98.9723 149.1C91.6723 149.1 87.9223 145.85 87.9223 140.25V137.3H94.5723V139.55C94.5723 142.1 96.1723 143.05 98.9723 143.05C101.772 143.05 103.372 142.1 103.372 139.55V135.3C103.372 132.95 102.022 131.8 99.4223 131.8H95.2223V125.65H99.2223C101.422 125.65 102.672 124.5 102.672 122.4V119.55C102.672 117.45 101.322 116.25 98.8223 116.25C96.3723 116.25 95.0223 117.45 95.0223 119.55V120.95H88.4223V118.6C88.4223 113 92.7223 110.15 98.8223 110.15C104.922 110.15 109.322 113 109.322 118.6V122.6C109.322 125.45 107.872 127.5 105.572 128.55C108.572 129.4 110.022 131.8 110.022 134.85ZM128.302 139.05V120.25C128.302 117.7 126.752 116.25 124.352 116.25C121.852 116.25 120.402 117.7 120.402 120.25V139.05C120.402 141.65 121.852 143.05 124.352 143.05C126.752 143.05 128.302 141.65 128.302 139.05ZM134.902 119.8V139.55C134.902 145.35 131.152 149.1 124.352 149.1C117.502 149.1 113.752 145.35 113.752 139.55V119.8C113.752 113.9 117.502 110.15 124.352 110.15C131.152 110.15 134.902 113.9 134.902 119.8ZM153.205 139.05V120.25C153.205 117.7 151.655 116.25 149.255 116.25C146.755 116.25 145.305 117.7 145.305 120.25V139.05C145.305 141.65 146.755 143.05 149.255 143.05C151.655 143.05 153.205 141.65 153.205 139.05ZM159.805 119.8V139.55C159.805 145.35 156.055 149.1 149.255 149.1C142.405 149.1 138.655 145.35 138.655 139.55V119.8C138.655 113.9 142.405 110.15 149.255 110.15C156.055 110.15 159.805 113.9 159.805 119.8ZM187.057 123C187.057 130.85 182.857 135.3 174.857 135.3H170.657V148.65H164.057V110.65H174.857C182.857 110.65 187.057 115.1 187.057 123ZM180.457 123C180.457 118.4 178.207 116.75 174.357 116.75H170.657V129.2H174.357C178.207 129.2 180.457 127.55 180.457 123Z"
      fill="#A088FF"
      fillOpacity="0.2"
    />
  ),
  2: (
    <>
      <g opacity="0.2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.849 101C129.657 101 134.065 102.709 137.5 105.553C140.935 102.709 145.343 101 150.151 101C161.113 101 170 109.887 170 120.849C170 125.657 168.291 130.065 165.447 133.5C168.291 136.935 170 141.343 170 146.151C170 157.113 161.113 166 150.151 166C145.343 166 140.935 164.291 137.5 161.447C134.065 164.291 129.657 166 124.849 166C113.887 166 105 157.113 105 146.151C105 141.343 106.709 136.935 109.553 133.5C106.709 130.065 105 125.657 105 120.849C105 109.887 113.887 101 124.849 101Z"
          fill="#A088FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.5 107.814L136.39 106.894C133.256 104.299 129.237 102.741 124.849 102.741C114.848 102.741 106.741 110.848 106.741 120.849C106.741 125.237 108.299 129.256 110.894 132.39L111.814 133.5L110.894 134.61C108.299 137.744 106.741 141.763 106.741 146.151C106.741 156.152 114.848 164.259 124.849 164.259C129.237 164.259 133.256 162.701 136.39 160.106L137.5 159.186L138.61 160.106C141.744 162.701 145.763 164.259 150.151 164.259C160.152 164.259 168.259 156.152 168.259 146.151C168.259 141.763 166.701 137.744 164.106 134.61L163.186 133.5L164.106 132.39C166.701 129.256 168.259 125.237 168.259 120.849C168.259 110.848 160.152 102.741 150.151 102.741C145.763 102.741 141.744 104.299 138.61 106.894L137.5 107.814ZM165.447 133.5C168.291 130.065 170 125.657 170 120.849C170 109.887 161.113 101 150.151 101C145.343 101 140.935 102.709 137.5 105.553C134.065 102.709 129.657 101 124.849 101C113.887 101 105 109.887 105 120.849C105 125.657 106.709 130.065 109.553 133.5C106.709 136.935 105 141.343 105 146.151C105 157.113 113.887 166 124.849 166C129.657 166 134.065 164.291 137.5 161.447C140.935 164.291 145.343 166 150.151 166C161.113 166 170 157.113 170 146.151C170 141.343 168.291 136.935 165.447 133.5Z"
          fill="black"
        />
      </g>
    </>
  ),
  3: (
    <path
      d="M96.1083 130.6H89.9583V110.65H109.008V116.75H96.5583V124.25C97.8083 123.25 99.6583 122.6 101.558 122.6C107.108 122.6 109.908 125.65 109.908 130.75V139.05C109.908 145.25 106.508 149.1 99.6083 149.1C92.6083 149.1 88.7583 145.35 88.7583 138.35H95.4083C95.4083 141.8 97.0083 143.05 99.6083 143.05C102.008 143.05 103.308 141.9 103.308 139.05V131.95C103.308 129.65 102.258 128.7 100.158 128.7C98.5083 128.7 97.1083 129.5 96.1083 130.6ZM128.217 139.05V120.25C128.217 117.7 126.667 116.25 124.267 116.25C121.767 116.25 120.317 117.7 120.317 120.25V139.05C120.317 141.65 121.767 143.05 124.267 143.05C126.667 143.05 128.217 141.65 128.217 139.05ZM134.817 119.8V139.55C134.817 145.35 131.067 149.1 124.267 149.1C117.417 149.1 113.667 145.35 113.667 139.55V119.8C113.667 113.9 117.417 110.15 124.267 110.15C131.067 110.15 134.817 113.9 134.817 119.8ZM153.119 139.05V120.25C153.119 117.7 151.569 116.25 149.169 116.25C146.669 116.25 145.219 117.7 145.219 120.25V139.05C145.219 141.65 146.669 143.05 149.169 143.05C151.569 143.05 153.119 141.65 153.119 139.05ZM159.719 119.8V139.55C159.719 145.35 155.969 149.1 149.169 149.1C142.319 149.1 138.569 145.35 138.569 139.55V119.8C138.569 113.9 142.319 110.15 149.169 110.15C155.969 110.15 159.719 113.9 159.719 119.8ZM186.971 123C186.971 130.85 182.771 135.3 174.771 135.3H170.571V148.65H163.971V110.65H174.771C182.771 110.65 186.971 115.1 186.971 123ZM180.371 123C180.371 118.4 178.121 116.75 174.271 116.75H170.571V129.2H174.271C178.121 129.2 180.371 127.55 180.371 123Z"
      fill="#A088FF"
      fillOpacity="0.2"
    />
  ),
  4: (
    <>
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.807 106.759C113.551 99.0802 126.105 99.0802 133.848 106.759L137.5 110.382L141.152 106.759C148.895 99.0802 161.449 99.0802 169.193 106.759C176.936 114.439 176.936 126.889 169.193 134.569L137.5 166L105.807 134.569C98.0642 126.889 98.0642 114.439 105.807 106.759Z"
        fill="#FF69CA"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.103 106.049C113.236 97.9835 126.419 97.9835 134.552 106.049L137.5 108.973L140.448 106.049C148.581 97.9835 161.764 97.9835 169.897 106.049C178.034 114.12 178.034 127.208 169.897 135.279L137.5 167.408L105.103 135.279C96.9656 127.208 96.9656 114.12 105.103 106.049ZM133.144 107.47C125.79 100.177 113.865 100.177 106.512 107.47C99.1628 114.758 99.1628 126.571 106.512 133.859L137.5 164.592L168.488 133.859C175.837 126.571 175.837 114.758 168.488 107.47C161.135 100.177 149.21 100.177 141.856 107.47L137.5 111.79L133.144 107.47Z"
        fill="black"
      />
    </>
  ),
  5: (
    <path
      d="M109.225 110.65V115.8L97.5254 148.65H90.4254L102.075 116.75H88.5754V110.65H109.225ZM126.349 139.05V120.25C126.349 117.7 124.799 116.25 122.399 116.25C119.899 116.25 118.449 117.7 118.449 120.25V139.05C118.449 141.65 119.899 143.05 122.399 143.05C124.799 143.05 126.349 141.65 126.349 139.05ZM132.949 119.8V139.55C132.949 145.35 129.199 149.1 122.399 149.1C115.549 149.1 111.799 145.35 111.799 139.55V119.8C111.799 113.9 115.549 110.15 122.399 110.15C129.199 110.15 132.949 113.9 132.949 119.8ZM151.252 139.05V120.25C151.252 117.7 149.702 116.25 147.302 116.25C144.802 116.25 143.352 117.7 143.352 120.25V139.05C143.352 141.65 144.802 143.05 147.302 143.05C149.702 143.05 151.252 141.65 151.252 139.05ZM157.852 119.8V139.55C157.852 145.35 154.102 149.1 147.302 149.1C140.452 149.1 136.702 145.35 136.702 139.55V119.8C136.702 113.9 140.452 110.15 147.302 110.15C154.102 110.15 157.852 113.9 157.852 119.8ZM185.104 123C185.104 130.85 180.904 135.3 172.904 135.3H168.704V148.65H162.104V110.65H172.904C180.904 110.65 185.104 115.1 185.104 123ZM178.504 123C178.504 118.4 176.254 116.75 172.404 116.75H168.704V129.2H172.404C176.254 129.2 178.504 127.55 178.504 123Z"
      fill="#A088FF"
      fillOpacity="0.2"
    />
  ),
  6: (
    <>
      <g opacity="0.2">
        <path d="M168.6 151.906L155.153 165.353L105.4 115.6L118.847 102.153L168.6 151.906Z" fill="#87F653" />
        <path d="M155.153 102.153L168.6 115.6L118.847 165.353L105.4 151.906L155.153 102.153Z" fill="#87F653" />
      </g>
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M170.721 152.027L155.153 167.595L137 149.442L118.847 167.595L103.279 152.027L121.432 133.874L103.279 115.721L118.847 100.153L137 118.306L155.153 100.153L170.721 115.721L152.568 133.874L170.721 152.027ZM150.447 133.874L168.6 152.027L155.153 165.474L137 147.321L118.847 165.474L105.4 152.027L123.553 133.874L105.4 115.721L118.847 102.274L137 120.427L155.153 102.274L168.6 115.721L150.447 133.874Z"
        fill="black"
      />
    </>
  ),
  7: (
    <path
      d="M83.3227 148.65H76.7227V116.75H72.9727V110.65H83.3227V148.65ZM90.2613 154.55L88.6113 151.25C91.1113 150.15 91.6613 148.55 91.6613 144.85V142.35H98.9613V145.35C98.9613 150.9 96.1613 153.95 90.2613 154.55ZM118 139.05V120.25C118 117.7 116.45 116.25 114.05 116.25C111.55 116.25 110.1 117.7 110.1 120.25V139.05C110.1 141.65 111.55 143.05 114.05 143.05C116.45 143.05 118 141.65 118 139.05ZM124.6 119.8V139.55C124.6 145.35 120.85 149.1 114.05 149.1C107.2 149.1 103.45 145.35 103.45 139.55V119.8C103.45 113.9 107.2 110.15 114.05 110.15C120.85 110.15 124.6 113.9 124.6 119.8ZM142.902 139.05V120.25C142.902 117.7 141.352 116.25 138.952 116.25C136.452 116.25 135.002 117.7 135.002 120.25V139.05C135.002 141.65 136.452 143.05 138.952 143.05C141.352 143.05 142.902 141.65 142.902 139.05ZM149.502 119.8V139.55C149.502 145.35 145.752 149.1 138.952 149.1C132.102 149.1 128.352 145.35 128.352 139.55V119.8C128.352 113.9 132.102 110.15 138.952 110.15C145.752 110.15 149.502 113.9 149.502 119.8ZM167.804 139.05V120.25C167.804 117.7 166.254 116.25 163.854 116.25C161.354 116.25 159.904 117.7 159.904 120.25V139.05C159.904 141.65 161.354 143.05 163.854 143.05C166.254 143.05 167.804 141.65 167.804 139.05ZM174.404 119.8V139.55C174.404 145.35 170.654 149.1 163.854 149.1C157.004 149.1 153.254 145.35 153.254 139.55V119.8C153.254 113.9 157.004 110.15 163.854 110.15C170.654 110.15 174.404 113.9 174.404 119.8ZM201.657 123C201.657 130.85 197.457 135.3 189.457 135.3H185.257V148.65H178.657V110.65H189.457C197.457 110.65 201.657 115.1 201.657 123ZM195.057 123C195.057 118.4 192.807 116.75 188.957 116.75H185.257V129.2H188.957C192.807 129.2 195.057 127.55 195.057 123Z"
      fill="#A088FF"
      fillOpacity="0.2"
    />
  ),
};

const dayTitle = {
  1: (
    <path
      d="M111.457 39.59H107.497V20.45H105.247V16.79H111.457V39.59ZM119.94 22.22C119.94 24.05 121.26 25.28 123.09 25.28C124.92 25.28 126.3 24.05 126.3 22.22C126.3 20.39 124.92 19.16 123.09 19.16C121.26 19.16 119.94 20.39 119.94 22.22ZM116.01 22.22C116.01 18.47 119.01 15.8 123.09 15.8C127.2 15.8 130.23 18.47 130.23 22.22C130.23 25.94 127.2 28.61 123.09 28.61C119.01 28.61 116.01 25.94 116.01 22.22ZM139.68 38.72V41.72H117.54V34.19H135.15V32.63H117.54V29.6H139.11V37.13H121.53V38.72H139.68ZM139.11 15.8V28.58H135.15V15.8H139.11ZM146.022 40.91L142.572 38.84C146.982 34.34 148.962 28.88 149.112 22.07H143.712V18.47H149.112V14.81H153.102V18.47H158.592V22.07H153.072C153.012 23.57 152.922 25.01 152.712 26.42C154.152 30.62 156.762 34.85 160.002 38.03L156.942 40.49C154.692 38.21 152.712 35.3 151.242 32.36C150.072 35.54 148.362 38.39 146.022 40.91ZM165.582 29.36V41.72H161.592V15.8H165.582V25.55H168.942V29.36H165.582Z"
      fill="white"
    />
  ),
  2: (
    <path
      d="M103.146 39.59V34.22C103.146 31.76 103.806 30.41 105.606 29.15L110.376 25.73C111.366 25.01 111.846 24.05 111.846 22.85C111.846 21.08 111.096 20.15 109.476 20.15C107.856 20.15 107.106 21.11 107.106 22.97H103.146C103.146 18.44 105.666 16.49 109.476 16.49C113.286 16.49 115.836 18.44 115.836 22.85C115.836 25.61 114.876 27.5 112.926 28.82L108.366 31.97C107.496 32.57 107.076 33.26 107.076 34.4V35.96H115.836V39.59H103.146ZM122.401 22.22C122.401 24.05 123.721 25.28 125.551 25.28C127.381 25.28 128.761 24.05 128.761 22.22C128.761 20.39 127.381 19.16 125.551 19.16C123.721 19.16 122.401 20.39 122.401 22.22ZM118.471 22.22C118.471 18.47 121.471 15.8 125.551 15.8C129.661 15.8 132.691 18.47 132.691 22.22C132.691 25.94 129.661 28.61 125.551 28.61C121.471 28.61 118.471 25.94 118.471 22.22ZM142.141 38.72V41.72H120.001V34.19H137.611V32.63H120.001V29.6H141.571V37.13H123.991V38.72H142.141ZM141.571 15.8V28.58H137.611V15.8H141.571ZM148.483 40.91L145.033 38.84C149.443 34.34 151.423 28.88 151.573 22.07H146.173V18.47H151.573V14.81H155.563V18.47H161.053V22.07H155.533C155.473 23.57 155.383 25.01 155.173 26.42C156.613 30.62 159.223 34.85 162.463 38.03L159.403 40.49C157.153 38.21 155.173 35.3 153.703 32.36C152.533 35.54 150.823 38.39 148.483 40.91ZM168.043 29.36V41.72H164.053V15.8H168.043V25.55H171.403V29.36H168.043Z"
      fill="white"
    />
  ),
  3: (
    <path
      d="M116.109 31.31V34.55C116.109 37.91 113.859 39.86 109.479 39.86C105.099 39.86 102.849 37.91 102.849 34.55V32.78H106.839V34.13C106.839 35.66 107.799 36.23 109.479 36.23C111.159 36.23 112.119 35.66 112.119 34.13V31.58C112.119 30.17 111.309 29.48 109.749 29.48H107.229V25.79H109.629C110.949 25.79 111.699 25.1 111.699 23.84V22.13C111.699 20.87 110.889 20.15 109.389 20.15C107.919 20.15 107.109 20.87 107.109 22.13V22.97H103.149V21.56C103.149 18.2 105.729 16.49 109.389 16.49C113.049 16.49 115.689 18.2 115.689 21.56V23.96C115.689 25.67 114.819 26.9 113.439 27.53C115.239 28.04 116.109 29.48 116.109 31.31ZM122.547 22.22C122.547 24.05 123.867 25.28 125.697 25.28C127.527 25.28 128.907 24.05 128.907 22.22C128.907 20.39 127.527 19.16 125.697 19.16C123.867 19.16 122.547 20.39 122.547 22.22ZM118.617 22.22C118.617 18.47 121.617 15.8 125.697 15.8C129.807 15.8 132.837 18.47 132.837 22.22C132.837 25.94 129.807 28.61 125.697 28.61C121.617 28.61 118.617 25.94 118.617 22.22ZM142.287 38.72V41.72H120.147V34.19H137.757V32.63H120.147V29.6H141.717V37.13H124.137V38.72H142.287ZM141.717 15.8V28.58H137.757V15.8H141.717ZM148.629 40.91L145.179 38.84C149.589 34.34 151.569 28.88 151.719 22.07H146.319V18.47H151.719V14.81H155.709V18.47H161.199V22.07H155.679C155.619 23.57 155.529 25.01 155.319 26.42C156.759 30.62 159.369 34.85 162.609 38.03L159.549 40.49C157.299 38.21 155.319 35.3 153.849 32.36C152.679 35.54 150.969 38.39 148.629 40.91ZM168.189 29.36V41.72H164.199V15.8H168.189V25.55H171.549V29.36H168.189Z"
      fill="white"
    />
  ),
  4: (
    <path
      d="M110.619 25.1H114.579V31.58H116.799V35.24H114.579V39.59H110.619V35.24H102.159V32.15L108.789 16.49H113.019L106.959 31.58H110.619V25.1ZM122.547 22.22C122.547 24.05 123.867 25.28 125.697 25.28C127.527 25.28 128.907 24.05 128.907 22.22C128.907 20.39 127.527 19.16 125.697 19.16C123.867 19.16 122.547 20.39 122.547 22.22ZM118.617 22.22C118.617 18.47 121.617 15.8 125.697 15.8C129.807 15.8 132.837 18.47 132.837 22.22C132.837 25.94 129.807 28.61 125.697 28.61C121.617 28.61 118.617 25.94 118.617 22.22ZM142.287 38.72V41.72H120.147V34.19H137.757V32.63H120.147V29.6H141.717V37.13H124.137V38.72H142.287ZM141.717 15.8V28.58H137.757V15.8H141.717ZM148.629 40.91L145.179 38.84C149.589 34.34 151.569 28.88 151.719 22.07H146.319V18.47H151.719V14.81H155.709V18.47H161.199V22.07H155.679C155.619 23.57 155.529 25.01 155.319 26.42C156.759 30.62 159.369 34.85 162.609 38.03L159.549 40.49C157.299 38.21 155.319 35.3 153.849 32.36C152.679 35.54 150.969 38.39 148.629 40.91ZM168.189 29.36V41.72H164.199V15.8H168.189V25.55H171.549V29.36H168.189Z"
      fill="white"
    />
  ),
  5: (
    <path
      d="M107.461 28.76H103.771V16.79H115.201V20.45H107.731V24.95C108.481 24.35 109.591 23.96 110.731 23.96C114.061 23.96 115.741 25.79 115.741 28.85V33.83C115.741 37.55 113.701 39.86 109.561 39.86C105.361 39.86 103.051 37.61 103.051 33.41H107.041C107.041 35.48 108.001 36.23 109.561 36.23C111.001 36.23 111.781 35.54 111.781 33.83V29.57C111.781 28.19 111.151 27.62 109.891 27.62C108.901 27.62 108.061 28.1 107.461 28.76ZM122.196 22.22C122.196 24.05 123.516 25.28 125.346 25.28C127.176 25.28 128.556 24.05 128.556 22.22C128.556 20.39 127.176 19.16 125.346 19.16C123.516 19.16 122.196 20.39 122.196 22.22ZM118.266 22.22C118.266 18.47 121.266 15.8 125.346 15.8C129.456 15.8 132.486 18.47 132.486 22.22C132.486 25.94 129.456 28.61 125.346 28.61C121.266 28.61 118.266 25.94 118.266 22.22ZM141.936 38.72V41.72H119.796V34.19H137.406V32.63H119.796V29.6H141.366V37.13H123.786V38.72H141.936ZM141.366 15.8V28.58H137.406V15.8H141.366ZM148.277 40.91L144.827 38.84C149.237 34.34 151.217 28.88 151.367 22.07H145.967V18.47H151.367V14.81H155.357V18.47H160.847V22.07H155.327C155.267 23.57 155.177 25.01 154.967 26.42C156.407 30.62 159.017 34.85 162.257 38.03L159.197 40.49C156.947 38.21 154.967 35.3 153.497 32.36C152.327 35.54 150.617 38.39 148.277 40.91ZM167.837 29.36V41.72H163.847V15.8H167.837V25.55H171.197V29.36H167.837Z"
      fill="white"
    />
  ),
  6: (
    <path
      d="M109.488 20.15C107.928 20.15 107.118 20.96 107.118 22.55V25.46C107.928 24.8 109.338 24.38 110.598 24.38C113.988 24.38 115.818 26.21 115.818 29.48V34.13C115.818 37.61 113.568 39.86 109.488 39.86C105.378 39.86 103.128 37.61 103.128 34.13V22.28C103.128 18.47 105.378 16.49 109.488 16.49C113.418 16.49 115.518 18.56 115.548 22.22H111.588C111.558 20.87 110.868 20.15 109.488 20.15ZM111.858 33.83V30.17C111.858 28.7 111.228 28.07 109.908 28.07C108.228 28.07 107.118 29 107.118 30.44V33.83C107.118 35.39 107.838 36.23 109.488 36.23C111.078 36.23 111.858 35.39 111.858 33.83ZM122.269 22.22C122.269 24.05 123.589 25.28 125.419 25.28C127.249 25.28 128.629 24.05 128.629 22.22C128.629 20.39 127.249 19.16 125.419 19.16C123.589 19.16 122.269 20.39 122.269 22.22ZM118.339 22.22C118.339 18.47 121.339 15.8 125.419 15.8C129.529 15.8 132.559 18.47 132.559 22.22C132.559 25.94 129.529 28.61 125.419 28.61C121.339 28.61 118.339 25.94 118.339 22.22ZM142.009 38.72V41.72H119.869V34.19H137.479V32.63H119.869V29.6H141.439V37.13H123.859V38.72H142.009ZM141.439 15.8V28.58H137.479V15.8H141.439ZM148.351 40.91L144.901 38.84C149.311 34.34 151.291 28.88 151.441 22.07H146.041V18.47H151.441V14.81H155.431V18.47H160.921V22.07H155.401C155.341 23.57 155.251 25.01 155.041 26.42C156.481 30.62 159.091 34.85 162.331 38.03L159.271 40.49C157.021 38.21 155.041 35.3 153.571 32.36C152.401 35.54 150.691 38.39 148.351 40.91ZM167.911 29.36V41.72H163.921V15.8H167.911V25.55H171.271V29.36H167.911Z"
      fill="white"
    />
  ),
  7: (
    <path
      d="M115.631 16.79V19.88L108.611 39.59H104.351L111.341 20.45H103.241V16.79H115.631ZM121.375 22.22C121.375 24.05 122.695 25.28 124.525 25.28C126.355 25.28 127.735 24.05 127.735 22.22C127.735 20.39 126.355 19.16 124.525 19.16C122.695 19.16 121.375 20.39 121.375 22.22ZM117.445 22.22C117.445 18.47 120.445 15.8 124.525 15.8C128.635 15.8 131.665 18.47 131.665 22.22C131.665 25.94 128.635 28.61 124.525 28.61C120.445 28.61 117.445 25.94 117.445 22.22ZM141.115 38.72V41.72H118.975V34.19H136.585V32.63H118.975V29.6H140.545V37.13H122.965V38.72H141.115ZM140.545 15.8V28.58H136.585V15.8H140.545ZM147.457 40.91L144.007 38.84C148.417 34.34 150.397 28.88 150.547 22.07H145.147V18.47H150.547V14.81H154.537V18.47H160.027V22.07H154.507C154.447 23.57 154.357 25.01 154.147 26.42C155.587 30.62 158.197 34.85 161.437 38.03L158.377 40.49C156.127 38.21 154.147 35.3 152.677 32.36C151.507 35.54 149.797 38.39 147.457 40.91ZM167.017 29.36V41.72H163.027V15.8H167.017V25.55H170.377V29.36H167.017Z"
      fill="white"
    />
  ),
};

const fillTitleColor = {
  normal: '#A088FF',
  today: '#FF6CCE',
};

const fillItems = {
  success: (
    <>
      <path
        opacity="0.2"
        d="M34 155C63.447 131.234 152.048 60.263 122.316 83.6709C112.681 91.2556 104.627 101.514 97.0228 111.033C86.1649 124.624 76.2764 139.018 66.7133 153.538C63.3912 158.582 60.0902 163.645 56.8366 168.733C56.5281 169.216 50.2675 178.352 55.3734 174.373C74.0925 159.783 89.7379 142.088 109.251 128.265C122.896 118.599 164.178 90.1977 151.162 100.694C133.932 114.588 118.377 127.95 103.712 144.766C93.5872 156.375 80.0429 170.327 75.3881 185.443C74.666 187.788 76.4391 185.263 77.7397 184.242C85.7251 177.973 93.3947 171.331 101.308 164.974C125.472 145.563 149.343 125.655 174.469 107.482C174.932 107.147 182.754 101.454 183.144 101.843C183.145 101.844 170.979 113.993 170.602 114.375C151.787 133.404 132.839 155.662 120.382 179.49C120.177 179.882 115.177 189.849 118.03 188.942C125.389 186.602 132.435 177.692 137.679 172.65C160.433 150.772 184.361 130.183 209.377 110.929C209.933 110.501 217.939 103.226 219.097 103.722C219.711 103.985 207.938 116.018 207.705 116.255C189.479 134.78 168.456 156.807 157.694 180.796C156.702 183.008 152.201 191.715 158.008 185.913C168.416 175.512 178.59 165.094 189.519 155.209C205.88 140.411 222.099 126.42 240 113.644"
        stroke="#FF6CCE"
        strokeWidth="23"
        strokeLinecap="round"
      />
      <path
        d="M70.1599 121.876C70.0279 122.668 69.8519 123.416 69.5879 124.208C72.0079 127.288 76.1879 129.928 80.1479 131.336L77.0679 135.78C73.6799 134.46 69.8519 131.996 67.1679 129.268C64.9679 132.568 61.8439 135.252 58.3679 136.704L54.4519 132.744C59.6879 130.544 63.2959 126.672 64.3079 121.876H56.1239V116.904H64.3079V112.988H70.2039V116.904H78.2559V121.876H70.1599ZM82.3479 136.748V114.44H88.1999V122.756H93.1279V128.3H88.1999V136.748H82.3479ZM56.9599 152.236V138.112H88.1999V152.236H56.9599ZM82.3479 147.396V142.952H62.7679V147.396H82.3479ZM95.3451 139.652V126.232C95.3451 118.884 99.2611 114.616 105.465 114.616C111.669 114.616 115.585 118.884 115.585 126.232V139.652C115.585 146.912 111.669 151.18 105.465 151.18C99.2611 151.18 95.3451 146.912 95.3451 139.652ZM100.933 126.232V139.652C100.933 143.832 102.561 145.9 105.465 145.9C108.369 145.9 109.953 143.832 109.953 139.652V126.232C109.953 122.052 108.369 119.984 105.465 119.984C102.561 119.984 100.933 122.052 100.933 126.232ZM122.801 141.016H116.905V135.472H122.801V128.652H116.905V123.108H122.801V114.44H128.609V152.456H122.801V141.016ZM154.47 114.44H158.43C163.974 114.44 167.626 117.872 167.626 122.536C167.626 126.892 164.37 130.192 159.354 130.544V133.932H169.562V138.992H144.262V133.932H153.59V130.544C148.53 130.236 145.318 126.892 145.318 122.536C145.318 117.872 148.882 114.44 154.47 114.44ZM158.21 119.148H154.69C152.314 119.148 150.906 120.556 150.906 122.536C150.906 124.472 152.314 125.88 154.69 125.88H158.21C160.586 125.88 162.038 124.472 162.038 122.536C162.038 120.556 160.586 119.148 158.21 119.148ZM171.938 114.44H177.79V125.528H182.718V131.072H177.79V142.38H171.938V114.44ZM178.582 152.236H146.55V141.104H152.358V147H178.582V152.236ZM218.815 133.404V138.464H185.727V124.208H212.567V120.072H185.727V115.056H218.419V129.092H191.579V133.404H218.815ZM220.267 145.68V151.004H183.879V145.68H191.491V139.784H197.343V145.68H206.847V139.784H212.655V145.68H220.267Z"
        fill="#FF6CCE"
      />
    </>
  ),
  fail: (
    <path
      d="M134.123 148.056V152.456H101.651V141.412H127.479V139.124H101.651V134.68H133.287V145.724H107.503V148.056H134.123ZM133.287 114.44V133.184H127.479V114.44H133.287ZM106.403 114.44H112.255C112.255 116.552 111.991 118.532 111.551 120.424C114.191 123.768 118.107 126.496 122.375 128.256L119.251 132.788C115.731 131.16 112.167 128.696 109.439 125.924C107.723 129.092 105.303 131.732 102.443 133.58L98.1308 129.928C103.367 126.76 106.403 121.436 106.403 114.44ZM172.904 114.44V152.456H167.404V134.284H164.456V152.016H159V114.616H164.456V128.96H167.404V114.44H172.904ZM157.416 115.056V120.38H140.036V115.056H157.416ZM157.68 145.548V150.784H139.684V145.548H142.324V123.108H147.604V145.548H149.276L150.86 123.108H156.228C155.612 130.588 155.128 138.024 154.556 145.548H157.68Z"
      fill="#AFB8C1"
    />
  ),
};

const voteStamp = {
  0: (
    <>
      <path
        d="M76.0001 156.75C88.5646 156.75 98.7501 146.565 98.7501 134C98.7501 121.436 88.5646 111.25 76.0001 111.25C63.4356 111.25 53.2501 121.436 53.2501 134C53.2501 146.565 63.4356 156.75 76.0001 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="68.5001" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="83.5001" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M90.0001 134C90.0001 141.732 83.7321 148 76.0001 148C68.2681 148 62.0001 141.732 62.0001 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M137 156.75C149.565 156.75 159.75 146.565 159.75 134C159.75 121.436 149.565 111.25 137 111.25C124.436 111.25 114.25 121.436 114.25 134C114.25 146.565 124.436 156.75 137 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="129.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="144.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M151 134C151 141.732 144.732 148 137 148C129.268 148 123 141.732 123 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.565 156.75 220.75 146.565 220.75 134C220.75 121.436 210.565 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
    </>
  ),
  1: (
    <>
      <path
        d="M76.0001 156.75C88.5646 156.75 98.7501 146.565 98.7501 134C98.7501 121.436 88.5646 111.25 76.0001 111.25C63.4356 111.25 53.2501 121.436 53.2501 134C53.2501 146.565 63.4356 156.75 76.0001 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="68.5001" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="83.5001" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M90.0001 134C90.0001 141.732 83.7321 148 76.0001 148C68.2681 148 62.0001 141.732 62.0001 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M137 156.75C149.565 156.75 159.75 146.565 159.75 134C159.75 121.436 149.565 111.25 137 111.25C124.436 111.25 114.25 121.436 114.25 134C114.25 146.565 124.436 156.75 137 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="129.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="144.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M151 134C151 141.732 144.732 148 137 148C129.268 148 123 141.732 123 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.565 156.75 220.75 146.565 220.75 134C220.75 121.436 210.565 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.564 156.75 220.75 146.565 220.75 134C220.75 121.436 210.564 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.564 156.75 220.75 146.565 220.75 134C220.75 121.436 210.564 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M76 156.75C88.5645 156.75 98.75 146.565 98.75 134C98.75 121.436 88.5645 111.25 76 111.25C63.4355 111.25 53.25 121.436 53.25 134C53.25 146.565 63.4355 156.75 76 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="68.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="83.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M90 134C90 141.732 83.732 148 76 148C68.268 148 62 141.732 62 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
    </>
  ),
  2: (
    <>
      <path
        d="M198 156.75C210.564 156.75 220.75 146.565 220.75 134C220.75 121.436 210.564 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M76 156.75C88.5645 156.75 98.75 146.565 98.75 134C98.75 121.436 88.5645 111.25 76 111.25C63.4355 111.25 53.25 121.436 53.25 134C53.25 146.565 63.4355 156.75 76 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="68.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="83.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M90 134C90 141.732 83.732 148 76 148C68.268 148 62 141.732 62 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M137 156.75C149.564 156.75 159.75 146.565 159.75 134C159.75 121.436 149.564 111.25 137 111.25C124.436 111.25 114.25 121.436 114.25 134C114.25 146.565 124.436 156.75 137 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="129.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="144.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M151 134C151 141.732 144.732 148 137 148C129.268 148 123 141.732 123 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
    </>
  ),
  3: (
    <>
      <path
        d="M76 156.75C88.5645 156.75 98.75 146.565 98.75 134C98.75 121.436 88.5645 111.25 76 111.25C63.4355 111.25 53.25 121.436 53.25 134C53.25 146.565 63.4355 156.75 76 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="68.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="83.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M90 134C90 141.732 83.732 148 76 148C68.268 148 62 141.732 62 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M137 156.75C149.564 156.75 159.75 146.565 159.75 134C159.75 121.436 149.564 111.25 137 111.25C124.436 111.25 114.25 121.436 114.25 134C114.25 146.565 124.436 156.75 137 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="129.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="144.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M151 134C151 141.732 144.732 148 137 148C129.268 148 123 141.732 123 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.564 156.75 220.75 146.565 220.75 134C220.75 121.436 210.564 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#EAEEF2"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="#AFB8C1" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="#AFB8C1"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <path
        d="M198 156.75C210.564 156.75 220.75 146.565 220.75 134C220.75 121.436 210.564 111.25 198 111.25C185.436 111.25 175.25 121.436 175.25 134C175.25 146.565 185.436 156.75 198 156.75Z"
        fill="#FFC700"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
      <circle cx="190.5" cy="128.5" r="2.5" fill="black" />
      <circle cx="205.5" cy="128.5" r="2.5" fill="black" />
      <path
        d="M212 134C212 141.732 205.732 148 198 148C190.268 148 184 141.732 184 134"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="square"
      />
    </>
  ),
};
